import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { Input } from 'src/editor/shared/ui-lib/input'

interface MenuItemTitleProps {
  number: number
  text: string
  updateText: (e: string) => void
  remove: () => void
  isMoveUpAvailable?: boolean
  isMoveDownAvailable?: boolean
  sortUp?: () => void
  sortDown?: () => void
}

export const MenuItemTitle = ({
  number,
  isMoveUpAvailable = false,
  isMoveDownAvailable = false,
  remove,
  updateText,
  text,
  sortUp,
  sortDown,
}: MenuItemTitleProps) => {
  const { t } = useTranslation()
  return (
    <>
      <div className="flex items-center justify-between">
        <GroupTitle className="mt-0 mb-0" withoutHorizontalLine>
          {t('entity_settings.menu.group.menu_item.heading_icu', {
            count: number,
          })}
        </GroupTitle>
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="far fa-trash-alt cursor-pointer text-error-500 transition hover:scale-125"
            onClick={remove}
          />
          {isMoveUpAvailable && (
            <button
              type="button"
              className="fas fa-chevron-up mt-1 cursor-pointer text-iconSecondary transition hover:scale-125"
              key="up"
              onClick={sortUp}
            />
          )}
          {isMoveDownAvailable && (
            <button
              type="button"
              className="fa-chevron-down fas cursor-pointer text-iconSecondary transition hover:scale-125"
              key="down"
              onClick={sortDown}
            />
          )}
        </div>
      </div>
      <Input
        value={text}
        onChange={updateText}
        placeholder={t('entity_settings.menu.item.text_placeholder')}
      />
    </>
  )
}
